
const TickIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.67268 23.413C10.4488 24.1985 12.1773 23.9381 12.3634 22.703C13.5213 15.0347 19.3154 8.56554 23.7001 2.46963C24.9158 0.780384 22.1204 -0.824343 20.9204 0.844795C16.9136 6.41473 11.8635 12.2757 9.8878 19.0346C7.63006 16.7272 5.36321 14.4417 2.83096 12.4142C1.22728 11.1296 -1.06669 13.3927 0.554266 14.6908C3.85348 17.3334 6.70464 20.415 9.67268 23.413Z"
        fill={props?.color ?? "#2558BC"}
      />
    </svg>
  );
};
 
export default TickIcon;

